export const CLIENTS = {
  GET_CLIENTS: 'GET_CLIENTS',
  GET_CLIENTS_SUCCESS: 'GET_CLIENTS_SUCCESS',
  GET_CLIENTS_FAIL: 'GET_CLIENTS_FAIL',

  GET_COMPANY_CLIENTS_LIST: 'GET_COMPANY_CLIENTS_LIST',
  GET_COMPANY_CLIENTS_LIST_SUCCESS: 'GET_COMPANY_CLIENTS_LIST_SUCCESS',
  GET_COMPANY_CLIENTS_LIST_FAIL: 'GET_COMPANY_CLIENTS_LIST_FAIL',

  GET_COMPANY_CLIENTS: 'GET_COMPANY_CLIENTS',
  GET_COMPANY_CLIENTS_SUCCESS: 'GET_COMPANY_CLIENTS_SUCCESS',
  GET_COMPANY_CLIENTS_FAIL: 'GET_COMPANY_CLIENTS_FAIL',

  GET_COMPANY_CLIENTS_POPUP: 'GET_COMPANY_CLIENTS_POPUP',
  GET_COMPANY_CLIENTS_POPUP_SUCCESS: 'GET_COMPANY_CLIENTS_POPUP_SUCCESS',
  GET_COMPANY_CLIENTS_POPUP_FAIL: 'GET_COMPANY_CLIENTS_POPUP_FAIL',

  POST_CLIENTS: 'POST_CLIENTS',

  PATCH_COMPANY_CLIENT_BLOCK: 'PATCH_COMPANY_CLIENT_BLOCK',
  PATCH_COMPANY_CLIENT_RETURN: 'PATCH_COMPANY_CLIENT_RETURN',
  POST_COMPANIES_CLIENTS: 'POST_COMPANIES_CLIENTS',

  PATCH_COMPANIES_CLIENTS: 'PATCH_COMPANIES_CLIENTS',

  CLEAR_CLIENTS: 'CLEAR_CLIENTS'
};
